<template>
	<pagina-erro
		titulo="Atualização do CPF do Familiar Encerrado"
		icone="fa fa-hourglass-end"
		imagemTexto="centralservidor-logo-texto.png"
		imagem="centralservidor-logo.png"
		texto="Conforme portaria 06/2022-SEGES, o período do recadastramento se encerrou." >
	</pagina-erro>
</template>

<script >
import PaginaErro from '@/components/pagina-erro'

export default {
	name: 'Encerrado',
	components: {
		PaginaErro
	}
}
</script>




// WEBPACK FOOTER //
// encerrado.vue?3e961bdf